// Session-only memory of the tracked phone number Invoca assigned to a given
// BASE number. Needed because `reswapInvocaNumbers` (pnapi.resetRun()+run()) is
// global: acquiring a placement for a new base wipes Invoca's record of every
// other base's placement, including ones already shown earlier in the session.
// Once that happens, `PNAPI.placements()` has nothing left to read for the
// earlier base, even though Invoca would hand out the exact same tracked number
// for it again (confirmed in prod: a given base gets the same tracked number for
// the whole session, independent of which address put it on screen) - the gap is
// purely that nothing kept a record of it once the live placement was gone.
//
// Keyed on the base number alone, not on address: Invoca's assignment is a
// property of the base, not of the address that happened to be showing it, so
// keying on address+base only produces misses - a different address on an
// already-attempted base would find no cache entry, no live placement, and the
// existing "attempted once per base" guard in useTrackedTfn would refuse to
// retrigger a reswap, leaving it stuck on the untracked number.
//
// A plain module-level Map, not sessionStorage: it only needs to survive for the
// current tab's life, same scope as the rest of redux state, which is not
// persisted across a reload either.
const assignedNumbers = new Map();

const digits = (value) => String(value || '').replace(/\D/g, '');

export const getAssignedPhoneNumber = (baseTfn) => {
  const key = digits(baseTfn);
  return key ? assignedNumbers.get(key) || '' : '';
};

export const setAssignedPhoneNumber = (baseTfn, phoneNumber) => {
  const key = digits(baseTfn);
  if (!key || !phoneNumber) {
    return;
  }
  assignedNumbers.set(key, phoneNumber);
};

export const clearAssignedPhoneNumbers = () => {
  assignedNumbers.clear();
};
